import { useState, useEffect, memo, useRef } from 'react';
import { Tooltip, StandardTooltipWindow } from './Tooltip';
import _uniqueId from 'lodash/uniqueId';

const DropDownLabel = (props) => {
    const { toggleOpen, classStr = 'drop', selected } = props;

    return (
        <div className={`${classStr}-hold value-hold icon-${selected.icon}`} onClick={toggleOpen}>
            <div aria-hidden="true" className="icon-selectarrow">
                {selected.label}
            </div>
        </div>
    );
};
const DropDown = (props) => {
    const { selected: selectedObj, onChange, classStr = 'drop', focus, label, list, tooltip, disabled = false, tooltipPlace = 'left' } = props;
    const [open, setOpen] = useState(false);
    const [selectid] = useState(_uniqueId('field-'));
    const dropDownDom = useRef();

    const toggleOpen = () => {
        if (disabled) return;
        setOpen(true);
    };
    const close = (e) => {
        setOpen(false);
    };

    const onChangeSelected = (e) => {
        const tehSelected = list.find((item) => {
            return item.id + '' == e.target.value + '';
        });
        onChange(tehSelected);
    };
    useEffect(() => focus && setOpen(true), [focus]);
    useEffect(() => setOpen(false), [disabled]);

    useEffect(() => {
        if (open && tooltipPlace === 'bottom') {
            //move tooltip under open dropdown
            const ttip = dropDownDom.current.querySelector('.__react_component_tooltip');
            const wrap = dropDownDom.current.querySelector('.wrap');
            const { y, height } = wrap.getBoundingClientRect();
            const topoff = Math.floor(y + height);
            ttip.style.top = topoff + 'px';
        }
    }, [open]);

    return (
        <div ref={dropDownDom} className={`${classStr} dropdown ${open ? 'open' : 'closed'} ${disabled ? 'disabled' : ''}`} tabIndex={0} onMouseLeave={close} onFocus={(e) => setOpen(true)} onBlur={() => setOpen(false)}>
            <Tooltip id={label} tooltip={tooltip} window={<StandardTooltipWindow id={label} text={tooltip} tooltipPlace={tooltipPlace} />}>
                <label htmlFor={selectid}>{label}</label>
                <DropDownLabel selected={selectedObj} toggleOpen={toggleOpen} />
                <div className={'contain ' + (open ? 'open' : 'closed')}>
                    <div className={'wrap ' + (open ? 'open' : 'closed')}>
                        <select id={selectid} className={`${classStr}-control`} title={tooltip} value={selectedObj.id} size={list.length} onClick={toggleOpen} onChange={onChangeSelected} disabled={disabled}>
                            {list.map((t, i) => {
                                return (
                                    <option key={i} className={`${classStr}-item dropdown-item icon-${t.icon} ${t.id === selectedObj.id ? 'selected' : ''}`} title={t.label} value={t.id}>
                                        {t.label}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};
export default memo(DropDown);
